import React from "react";
import Select from "react-select";
import "react-select/dist/react-select.css";

class ReactSelect extends React.Component {
  state = {
    selectedOption: null
  };
  componentDidMount() {
    const data = this.props.allSchemas[0];
    const selectedOption = {
      value: data.name,
      label: data.name,
      id: data.id,
      key: this.props.state_key
    };
    this.setState({selectedOption});
    this.props.handleSelect(selectedOption, "single");
  }

  handleChange = selectedOption => {
    this.props.handleSelect(selectedOption, "single");
    this.setState({ selectedOption });

    // console.log(`Option selected:`, selectedOption);
  };
  render() {
    const { selectedOption } = this.state;
    let options = [];

    this.props.allSchemas &&
      this.props.allSchemas.map(data => {
        options.push({
          value: data.name,
          label: data.name,
          id: data.id,
          key: this.props.state_key
        });
        return data;
      });

    return (
      <Select
        clearable={false}
        value={selectedOption}
        onChange={this.handleChange}
        options={options}
      />
    );
  }
}

export default ReactSelect;



// WEBPACK FOOTER //
// ./src/views/AssetSchemas/AssetSchemas/Select.js